import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FuseAlertService {
    private readonly _onDismiss: ReplaySubject<string> = new ReplaySubject<string>(1);
    private readonly _onShow: ReplaySubject<{ message: string; duration: number; horizontalPosition: string; verticalPosition: string }> =
        new ReplaySubject<{ message: string; duration: number; horizontalPosition: string; verticalPosition: string }>(1);
    
    private renderer: Renderer2;
    private alertElement: HTMLElement | null = null;
    public companyId: number = 0;

    constructor(rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

     // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for onDismiss
     */
    get onDismiss(): Observable<any> {
        return this._onDismiss.asObservable();
    }
    /**
     * Getter for onShow
     */
    get onShow(): Observable<any> {
        return this._onShow.asObservable();
    }

 // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Dismiss the alert
     *
     * @param name
     */
        dismiss(name: string): void {
             // Return if the name is not provided
        if (!name) {
            return;
        }
        // Execute the observable
        this._onDismiss.next(name);
    }

     /**
     * Show the dismissed alert
     *
     * @param name
     */

    show(message: string, status: number): void {
        // Return if the name is not provided
        
        if (!message) {
            return;
        }
      
        let backgroundColor: string;   
        let TextColor: string;   
        let borderColor: string;   
        switch (true) {
            case status === 1: 
            // success
                TextColor = '#03543f'; 
                backgroundColor = '#f3faf7'; 
                borderColor = '#84e1bc'; 
                break;
            case status === 2:
                // warning
                TextColor = '#723b13'; 
                backgroundColor = '#fdfdea'; 
                borderColor = '#faca15';
                break;
            case status === 0:
                // danger
                TextColor = '#9b1c1c'; 
                backgroundColor = '#fdf2f2'; 
                borderColor = '#f8b4b4';
                break;
            case status === 3:
                // default
                TextColor = '#1f2937'; 
                backgroundColor = '#f9fafb'; 
                borderColor = '#d1d5db';
                message = "Something went wrong"; 
                break;
            case status === 4: 
            // danger
                TextColor = '#9b1c1c'; 
                backgroundColor = '#fdf2f2'; 
                borderColor = '#f8b4b4';
                message = message || "Item deleted successfully"; 
                break;
            case status !== 0 && message.length > 0:
                // primary
                TextColor = '#1e429f'; 
                backgroundColor = '#ebf5ff'; 
                borderColor = '#a4cafe';
                break;
            case message === "" || message === null:
                // warning
                TextColor = '#723b13'; 
                backgroundColor = '#fdfdea'; 
                borderColor = '#faca15';
                message = "No message provided"; 
                break;
            case this.companyId === 0:
                 // success
                TextColor = '#03543f'; 
                backgroundColor = '#f3faf7'; 
                borderColor = '#84e1bc';              
                break;
            default:
                // default
                TextColor = '#1f2937'; 
                backgroundColor = '#f9fafb'; 
                borderColor = '#d1d5db';
        }
        // Execute the observable
        this._onShow.next({
            message: message,
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top'
        });

        this.createAlertPopup(message, backgroundColor,TextColor,borderColor); 
    }

    private createAlertPopup(message: string, backgroundColor: string,TextColor: string, borderColor: string ) {
        if (this.alertElement) {
            this.renderer.removeChild(document.body, this.alertElement);
        }

        this.alertElement = this.renderer.createElement('div');
        this.renderer.setProperty(this.alertElement, 'innerText', message);
        this.renderer.setStyle(this.alertElement, 'position', 'fixed');
        this.renderer.setStyle(this.alertElement, 'top', '20px'); 
        this.renderer.setStyle(this.alertElement, 'left', '50%'); 
        this.renderer.setStyle(this.alertElement, 'transform', 'translateX(-50%)');
        this.renderer.setStyle(this.alertElement, 'background-color', backgroundColor); 
        this.renderer.setStyle(this.alertElement, 'color', TextColor);
        this.renderer.setStyle(this.alertElement, 'border-color', borderColor);
        this.renderer.setStyle(this.alertElement, 'border', '1px solid');
        this.renderer.setStyle(this.alertElement, 'min-width', '250px');
        this.renderer.setStyle(this.alertElement, 'padding', '12px 20px');
        this.renderer.setStyle(this.alertElement, 'border-radius', '4px');
        this.renderer.setStyle(this.alertElement, 'box-shadow', '0 2px 5px rgba(0, 0, 0, 0.3)');
        this.renderer.setStyle(this.alertElement, 'z-index', '1000');
        this.renderer.setStyle(this.alertElement, 'font-size', '16px');
        this.renderer.setStyle(this.alertElement, 'text-align', 'center');

        this.renderer.appendChild(document.body, this.alertElement);

        setTimeout(() => {
            if (this.alertElement) {
                this.renderer.removeChild(document.body, this.alertElement);
                this.alertElement = null;
            }
        }, 3000);
    }
}
